import { render, staticRenderFns } from "./ReturnAssets.vue?vue&type=template&id=27e639ee&scoped=true"
import script from "./ReturnAssets.js?vue&type=script&lang=js&external"
export * from "./ReturnAssets.js?vue&type=script&lang=js&external"
import style0 from "./ReturnAssets.vue?vue&type=style&index=0&id=27e639ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e639ee",
  null
  
)

export default component.exports